import { memo } from "react";
import { CSVLink } from "react-csv";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "./IconButton.tsx";

export const headersPedido = [
	{ label: "N Pedido", key: "pedido" },
	{ label: "Rota", key: "tipoRota" },
	{ label: "Frete Fiscal", key: "freteFiscal" },
	{ label: "ICMS", key: "icms" },
	{ label: "Pedagio", key: "pedagio" },
	{ label: "Classificação", key: "classificacao" },
	{ label: "Km", key: "km" },
	{ label: "Cliente", key: "cliente" },
	{ label: "Embarcador", key: "embarcador" },
	{ label: "Embarcador Estado", key: "embarcadorEstado" },
	{ label: "Destinatario", key: "destinatario" },
	{ label: "Destinatario Estado", key: "destinatarioEstado" },
	{ label: "Frete Motorista", key: "freteMotorista" },
	{ label: "Cidade Origem", key: "cidadeOrigem" },
	{ label: "Cidade Destino", key: "cidadeDestino" },
	{ label: "Observação", key: "observacao" },
];

export const headersVeiculo = [
	{ label: "Placa Cavalo", key: "placaCavalo" },
	{ label: "Placa Carreta", key: "placaCarreta" },
	{ label: "Placa Carreta 2", key: "placaCarreta2" },
	{ label: "Proprietário", key: "proprietario" },
	{ label: "Motorista", key: "motorista" },
	{ label: "Motorista 2", key: "motorista2" },
];

export const headersRota = [
	{ label: "Rota", key: "nome" },
	{ label: "Cidade Origem", key: "cidadeOrigem" },
	{ label: "Estado Origem", key: "estadoOrigem" },
	{ label: "Cidade Destino", key: "cidadeDestino" },
	{ label: "Estado Destino", key: "estadoDestino" },
];

export const headersViagens = [
	{ label: "Unidade Embarque", key: "unidEmbarque" },
	{ label: "Empresa", key: "empresa" },
	{ label: "Filial", key: "filial" },
	{ label: "Rota", key: "rota" },
	{ label: "Pedido", key: "pedido" },
	{ label: "CTE", key: "cte" },
	{ label: "Previsão Viagem", key: "previsaoEmbarque" },
	{ label: "Previsão Entrega", key: "previsaoEntrega" },
	{ label: "Data Hora Chegada Embarque", key: "dataHoraChegadaEmbarque" },
	{ label: "Data Hora Embarcado", key: "dataHoraEmbarcado" },
	{ label: "Data Hora Chegada Entrega", key: "dataHoraChegadaEntrega" },
	{ label: "Data Hora Entregue", key: "dataHoraEntregue" },
	{ label: "Aceite", key: "aceite" },
	{ label: "Status", key: "status" },
	{ label: "Placa Cavalo", key: "placaCavalo" },
	{ label: "Placa Carreta", key: "placaCarreta" },
	{ label: "Placa Carreta 2", key: "placaCarreta2" },
	{ label: "Proprietário", key: "proprietario" },
	{ label: "Motorista", key: "motorista" },
	{ label: "Frete Fiscal", key: "freteFiscal" },
	{ label: "ICMS", key: "icms" },
	{ label: "Frete Motorista", key: "freteMotorista" },
	{ label: "Adicional Empresa", key: "adicionalEmpresa" },
	{ label: "Adicional Motorista", key: "adicionalMotorista" },
	{ label: "Eixos", key: "numeroEixos" },
	{ label: "Pedágio", key: "pedagio" },
	{ label: "Descarga", key: "classificacao" },
	{ label: "Margem", key: "margem" },
	{ label: "Adiantamento", key: "adiantamento" },
	{ label: "Saldo", key: "saldo" },
	{ label: "Meio Pagamento", key: "meioPagamento" },
	{ label: "Meio Pagamento 2", key: "meioPagamento2" },
	{ label: "KM", key: "km" },
	{ label: "Cliente", key: "cliente" },
	{ label: "Embarcador", key: "embarcador" },
	{ label: "Destinatário", key: "destinatario" },
	{ label: "Load", key: "load" },
	{ label: "Mercadoria", key: "mercadoria" },
	{ label: "Peso", key: "peso" },
	{ label: "Embalagem", key: "embalagem" },
	{ label: "Observação", key: "observacao" },
	{ label: "Frota", key: "frota" },
	{ label: "Cancelado", key: "cancelado" },
	{ label: "Motivo", key: "motivo" },
	{ label: "Usuário Responsável", key: "usuarioResponsavel" },
	{ label: "Número de Entregas", key: "nEntregas" },
	{ label: "Comprovante", key: "comprovante" },
	{ label: "Check-In Feito", key: "checkInFeito" },
];

export const headersClassificacaoPontos = [
	{ label: "Classificação", key: "classificacao" },
	{ label: "Nome", key: "nome" },
	{ label: "Documento", key: "documento" },
	{ label: "Tipo", key: "tipo" },
	{ label: "KM Feitos", key: "kmFeitos" },
	{ label: "Viagens Feitas", key: "viagensFeitas" },
	{ label: "Pontos", key: "pontos" },
	{ label: "Placa", key: "placa" },
];

export enum ClasseCsv {
	idPedido = "idPedido",
	idVeiculo = "idVeiculo",
	idRota = "idRota",
	idEmbarque = "idEmbarque",
	idClassificacaoPontosMotorista = "idClassificacaoPontosMotorista",
	idClassificacaoPontosProprietario = "idClassificacaoPontosProprietario",
}

const csvLinkMap = {
	[ClasseCsv.idPedido]: {
		headers: headersPedido,
		filename: "Pedidos",
	},
	[ClasseCsv.idVeiculo]: {
		headers: headersVeiculo,
		filename: "Veiculos",
	},
	[ClasseCsv.idRota]: {
		headers: headersRota,
		filename: "Rotas",
	},
	[ClasseCsv.idEmbarque]: {
		headers: headersViagens,
		filename: "Viagens",
	},
	[ClasseCsv.idClassificacaoPontosMotorista]: {
		headers: headersClassificacaoPontos,
		filename: "ClassificacaoPontosMotorista",
	},
	[ClasseCsv.idClassificacaoPontosProprietario]: {
		headers: headersClassificacaoPontos,
		filename: "ClassificacaoPontosProprietario",
	},
};

function RenderCsvLink({
	classe,
	lista,
	disabled = false,
}: {
	classe: ClasseCsv | string;
	lista: any[];
	disabled?: boolean;
}) {
	if (!csvLinkMap[classe] || !lista || lista.length === 0) {
		return (
			<IconButton
				theme="dark"
				onClick={() => { }}
				icon="Download"
				size="2xl"
				backgroundColor="#FFFFFF"
				hoverColor="#CCC"
				disabled
			/>
		);
	}

	const { headers, filename } = csvLinkMap[classe];

	return (
		<CSVLink
			className="csv-botao"
			data={lista}
			headers={headers}
			filename={filename}
		>
			<Tooltip title={<p>Baixar dados em formato .csv</p>}>
				<span>
					<IconButton
						disabled={disabled}
						theme="dark"
						onClick={() => { }}
						icon="Download"
						size="2xl"
						backgroundColor="#FFFFFF"
						hoverColor="#CCC"
					/>
				</span>
			</Tooltip>
		</CSVLink>
	);
}

export default memo(RenderCsvLink);
